<template>
  <div>
    <Collapse v-model="isOpen">
      <Panel name="open">
        书籍详情
        <div slot="content">
          <el-form ref="formCustom" :inline="true" label-width="125px" :model="detailInfo">
            <el-form-item label="别名: ">
              <el-input
                style="width: 300px"
                v-model.trim="detailInfo.nickname"
                :disabled="doWhatTemp==='view'"
              />
            </el-form-item>
            <el-form-item label="序列号: ">
              <el-input style="width: 300px" disabled />
            </el-form-item>
            <br />
            <el-form-item label="ISBN: ">
              <el-input
                style="width: 300px"
                v-model.trim="detailInfo.ISBN"
                :disabled="doWhatTemp==='view'"
              />
            </el-form-item>
            <br />
            <el-form-item label="适龄: ">
              <el-checkbox-group v-model="tagForDetail.age">
                <el-checkbox
                  v-for="item in tagsForAge"
                  :label="item.id"
                  :key="item.id"
                  :disabled="doWhatTemp==='view'"
                >{{item.label}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <br />
            <el-form-item label="出版社: ">
              <el-checkbox-group v-model="tagForDetail.publisher" :max="1" style="width:800px">
                <el-checkbox
                  style="font-size:10px"
                  v-for="item in tagsForPublisher"
                  :label="item.id"
                  :key="item.id"
                  :disabled="doWhatTemp==='view'"
                >{{item.label}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <br />
            <el-form-item label="体裁: ">
              <el-checkbox-group v-model="tagForDetail.form">
                <el-checkbox
                  v-for="item in tagsForForm"
                  :label="item.id"
                  :key="item.id"
                  :disabled="doWhatTemp==='view'"
                >{{item.label}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <br />
            <el-form-item label="类型: ">
              <el-checkbox-group v-model="tagForDetail.type">
                <el-checkbox
                  v-for="item in tagsForType"
                  :label="item.id"
                  :key="item.id"
                  :disabled="doWhatTemp==='view'"
                >{{item.label}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <br />
            <el-form-item label="页数: ">
              <el-input
                style="width: 300px"
                v-model.trim="detailInfo.pageCnt"
                :disabled="doWhatTemp==='view'"
              />
            </el-form-item>
            <el-form-item label="字数: ">
              <el-input
                style="width: 300px"
                v-model.trim="detailInfo.wordCnt"
                :disabled="doWhatTemp==='view'"
              />
            </el-form-item>
            <br />
            <el-form-item label="是否母语: ">
              <el-checkbox-group v-model="tagForDetail.tongue" :max="1">
                <el-checkbox
                  v-for="item in tagsForTongue"
                  :label="item.id"
                  :key="item.id"
                  :disabled="doWhatTemp==='view'"
                >{{item.label}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <br />
            <el-form-item label="YL值: ">
              <el-input
                style="width: 300px"
                v-model.trim="detailInfo.IDX_YL"
                :disabled="doWhatTemp==='view'"
                :placeholder="(doWhatTemp=='edit')?'填写数值在0.0-10.0范围':''"
              />
            </el-form-item>
            <el-form-item label="AR值: ">
              <el-input
                style="width: 300px"
                v-model.trim="detailInfo.IDX_AR"
                :disabled="doWhatTemp==='view'"
                :placeholder="(doWhatTemp=='edit')?'填写数值在0.0-10.0范围':''"
              />
            </el-form-item>
            <br />
            <el-form-item label="蓝思值: ">
              <el-input
                style="width: 300px"
                v-model.trim="detailInfo.IDX_LX"
                :disabled="doWhatTemp==='view'"
              />
            </el-form-item>
            <el-form-item label="PERC值: ">
              <el-input
                style="width: 300px"
                v-model.trim="detailInfo.IDX_PERC"
                :disabled="doWhatTemp==='view'"
              />
            </el-form-item>
            <br />

            <el-form-item label="核心词汇: ">
              <el-input
                style="width: 300px"
                v-model.number="detailInfo.vocabulary"
                :disabled="doWhatTemp==='view'"
                :placeholder="(doWhatTemp=='edit')?'填写数值在50-9999范围':''"
              />
            </el-form-item>
            <br />
            <el-form-item label="CEFR值: ">
              <el-checkbox-group v-model="detailInfo.IDX_CEFR" style="width:800px">
                <el-checkbox
                  v-for="item in cefr"
                  :label="item"
                  :key="item"
                  :disabled="doWhatTemp==='view'"
                >{{item}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <br />
            <el-form-item label="主题: ">
              <el-checkbox-group v-model="tagForDetail.theme" style="width:800px">
                <el-checkbox
                  v-for="item in tagsForTheme"
                  :label="item.id"
                  :key="item.id"
                  :disabled="doWhatTemp==='view'"
                >{{item.label}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <br />
            <el-form-item label="获奖信息: ">
              <el-checkbox-group v-model="tagForDetail.award" style="width:800px">
                <el-checkbox
                  v-for="item in tagsForAward"
                  :label="item.id"
                  :key="item.id"
                  :disabled="doWhatTemp==='view'"
                >{{item.label}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <br />
            <el-form-item label="所属专辑: " v-if="detailInfo.bindAlbum.length>0">
              <el-table
                :data="detailInfo.bindAlbum"
                stripe
                border
                tooltip-effect="dark"
                style="width: 100%"
              >
                <el-table-column prop="id" label="专辑ID" align="center" width="110">
                  <template slot-scope="scope">
                    <a href="javascript:;" @click="gotoAlbum(scope.row.id)" style="color:#1d90e6">{{ scope.row.id}}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="专辑名称" align="center" width="200">
                  <template slot-scope="scope">
                    <a href="javascript:;" @click="gotoAlbum(scope.row.id)" style="color:#1d90e6">{{ scope.row.name}}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="status" label="上下架状态" align="center" width="120">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.status==0" type="gray">未上架</el-tag>
                    <el-tag v-else-if="scope.row.status==1" type="success">已上架</el-tag>
                    <el-tag v-else-if="scope.row.status==2" type="danger">被下架</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="res_count" label="内容数量" align="center" width="100"></el-table-column>
                <el-table-column prop="updated_at" label="更新时间" align="center" width="180">
                  <template slot-scope="scope">
                    <span>{{ scope.row.updated_at | formatDate2 }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
            <br />
            <el-form-item label="购买链接: ">
              <div
                v-for="(item,index) in detailInfo.buyUrls"
                :key="index"
                style="padding-bottom:10px"
              >
                来源:
                <el-input
                  style="width:100px;margin:0 20px 0 0"
                  v-model.trim="item.name"
                  :disabled="doWhatTemp==='view'"
                />链接:
                <el-input
                  style="width: 500px"
                  v-model.trim="item.url"
                  :disabled="doWhatTemp==='view'"
                />
                <a
                  href="javascript:;"
                  @click="addBuyUrl"
                  v-if="index==detailInfo.buyUrls.length-1 && doWhatTemp!='view'"
                >
                  <Icon type="ios-add-circle-outline" size="30" color="#C5C5C5" />
                </a>
                <a
                  href="javascript:;"
                  @click="delBuyUrl(index)"
                  v-if="index!=detailInfo.buyUrls.length-1 && doWhatTemp!='view'"
                >
                  <Icon type="ios-remove-circle-outline" size="30" color="#C5C5C5" />
                </a>
              </div>
            </el-form-item>
            <br />
            <el-form-item label="书籍简介: ">
              <el-input
                :rows="5"
                style="width: 690px"
                v-model.trim="detailInfo.desc"
                type="textarea"
                :disabled="doWhatTemp==='view'"
              />
            </el-form-item>
            <br />
          </el-form>
        </div>
      </Panel>
    </Collapse>
  </div>
</template>

<script>
import { formatDate } from "@/utils/util";
export default {
  name: "addBookDetail",
  components: {},
  data() {
    return {
      isOpen: "open",
      cefr: [
        "Pre A1",
        "A1",
        "A1+",
        "A2",
        "A2+",
        "B1",
        "B1+",
        "B2",
        "B2+",
        "C1",
        "C1+",
        "C2",
      ],
    };
  },
  created() {},
  filters: {
    formatDate2(d) {
      return formatDate(d, "yyyy-MM-dd hh:mm:ss");
    },
  },
  props: {
    detailInfo: {
      type: Object,
      default() {
        let temp = {
          nickname: "",
          ISBN: "",
          desc: "",
          pageCnt: "",
          wordCnt: "",
          IDX_YL: "",
          IDX_AR: "",
          IDX_LX: "",
          IDX_PERC: "",
          IDX_CEFR: [],
          vocabulary: null,
          buyUrls: [
            {
              name: "",
              url: "",
            },
          ],
          bindAlbum: [],
        };
        return temp;
      },
    },
    doWhatTemp: {
      type: String,
      default: "",
    },
    tagList: {
      type: Array,
      default: () => [],
    },
    tagForDetail: {
      type: Object,
      default() {
        let temp = {
          age: [],
          publisher: [],
          form: [],
          type: [],
          tongue: [],
          theme: [],
          award: [],
        };
        return temp;
      },
    },
  },
  watch: {},
  computed: {
    tagsForAge() {
      for (let i in this.tagList) {
        if (this.tagList[i].id == 75) {
          return this.tagList[i].children;
        }
      }
    },
    tagsForPublisher() {
      for (let i in this.tagList) {
        if (this.tagList[i].id == 81) {
          return this.tagList[i].children;
        }
      }
    },
    tagsForForm() {
      for (let i in this.tagList) {
        if (this.tagList[i].id == 78) {
          return this.tagList[i].children;
        }
      }
    },
    tagsForType() {
      for (let i in this.tagList) {
        if (this.tagList[i].id == 79) {
          return this.tagList[i].children;
        }
      }
    },
    tagsForTongue() {
      for (let i in this.tagList) {
        if (this.tagList[i].id == 80) {
          return this.tagList[i].children;
        }
      }
    },
    tagsForTheme() {
      for (let i in this.tagList) {
        if (this.tagList[i].id == 77) {
          return this.tagList[i].children;
        }
      }
    },
    tagsForAward() {
      for (let i in this.tagList) {
        if (this.tagList[i].id == 203) {
          return this.tagList[i].children;
        }
      }
    },
  },
  methods: {
    addBuyUrl() {
      let buyUrls = {
        name: "",
        url: "",
      };
      this.detailInfo.buyUrls.push(buyUrls);
    },
    delBuyUrl(index) {
      this.detailInfo.buyUrls.splice(index, 1);
    },
    gotoAlbum(id) {
      let routeUrl = this.$router.resolve({
        name: "addAlbum",
        query: {
          cpid: Number(this.$route.query.cpid),
          albumId: id,
          do: "view",
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// addBookAginDetail.vue?5c38a573